import {
    Half1Icon,
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from '../ui/dropdown-menu';
import { toast } from '../ui/use-toast';

function SplitCompetitionSportClassDialog({ competitionClass }) {

    const [isLoading, setIsLoading] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const navigate = useNavigate();

    const handleChange = async () => {
        setIsLoading(true);

        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/competitions/create-class`, {
                competitionId: competitionClass?.competition?.id,
                sportClassId: competitionClass?.sport_class_id,
                date: competitionClass?.date.split('T')[0],
                assessment: competitionClass?.assessment,
                splitClassId: competitionClass?.id,
            });
            toast({
                title: 'Ny-klass tillagd',
                description: `Ny-klass blev tillagd för ${competitionClass?.name}.`,
            });
            setIsDialogOpen(false);
            navigate(`/competition/${competitionClass?.competition?.id}/class/${response?.data?.createdSportClassId}`);
        } catch (error) {
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error.response?.data?.error || "Kunde inte skicka förfrågan.",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <Half1Icon className='mr-3'/>
                    Skapa ny-klass
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>Skapa ny-klass för {competitionClass?.name}</DialogTitle>
                    <DialogDescription>Är du helt säker på att du vill lägga till en ny-klass för {competitionClass?.name}?</DialogDescription>
                </DialogHeader>
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button type="submit" onClick={handleChange} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Skapa ny-klass</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default SplitCompetitionSportClassDialog;
